// 用户首页相关路由
export const homeRoutes = [
  {
    name: "home",
    path: "/home",
    redirect: "/educator/chat",
    //component: () => import("@/views/educator/EducatorHome.vue"),
    component: () => import("@/views/Home.vue"),
    children: [
      {
        name: "chat",
        path: "/chat",
        meta: { title: "创作中心" },
        component: () => import("@/views/ChatNew.vue"),
      },
      {
        name: "chat-id",
        path: "/chat/:id",
        meta: { title: "创作中心" },
        component: () => import("@/views/ChatNew.vue"),
      },
      {
        name: "member",
        path: "/member",
        meta: { title: "会员充值中心" },
        component: () => import("@/views/Member.vue"),
      },
      {
        name: "chat-app",
        path: "/apps",
        meta: { title: "应用中心" },
        component: () => import("@/views/ChatApps.vue"),
      },
     
      {
        name: "user-invitation",
        path: "/invite",
        meta: { title: "推广计划" },
        component: () => import("@/views/Invitation.vue"),
      },
      {
        name: "powerLog",
        path: "/powerLog",
        meta: { title: "消费日志" },
        component: () => import("@/views/PowerLog.vue"),
      },

      {
        name: "training",
        path: "/training",
        meta: { title: "数据标注" },
        component: () => import("@/views/tools/training/Training.vue"),
      },
      {
        name: "train-model",
        path: "/train-model",
        meta: { title: "AI体验" },
        component: () => import("@/views/tools/training/TrainModel.vue"),
      },
      {
        name: "vibe-coding",
        path: "/tool/vibe-coding",
        meta: { title: "氛围编程" },
        component: () => import("@/views/tools/code/VibeCoding.vue"),
      },
    ],
  },
];
